import React, {useEffect, useState} from "react";
import "./PaymentResponsive.scss";
import {useHistory, useParams} from "react-router";
import {useDispatchBasket, useBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import {clothing_product} from "../Clothing/Services_Clothing";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import {ArrowLeftOutlined, PlusCircleOutlined, MinusCircleOutlined} from '@ant-design/icons';
import {openNotificationWithIcon, Setup} from "../../Services";
import {useLocation} from "react-router-dom";
import {OnlineAddress} from "../../Components";
import CouponComponent from "../../Components/CouponComponent/CoponComponent";
import Rodal from "rodal";


function RewardInInvoice({item}) {
    return(
        <div className="off-sub-section" style={{
            width:"100%",
            padding:"5px 20px"
        }}>
            <span> {numberWithCommas(item.effect.value)} ریال </span>
            <span>{item.effect.title}</span>
        </div>
    )

}



function numberWithCommas(x) {
    if (x === 0) {
        return 0
    }
    if (x) {
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function PaymentResponsive({
                               showModal,set_coupon,coupon,couponStatus,addCoupon,
                               set_showModal,couponsList,coupon_finalize,merchantId,finalObj,redirectToGateWay}) {

    //hooks
    // const {merchantId, productId} = useParams()
    const history = useHistory()
    const location = useLocation();


    function convertPerToAm(per,max,amount) {
        console.log("per:",per)
        console.log("max:",max)
        console.log("amount:",amount)
        let price = amount*per/100;
        console.log("price : ",price)
        if(max>price){
            return numberWithCommas(price)
        }else {
            return numberWithCommas(max)
        }
    }




    useEffect(() => {
        console.log("Location : ", location);
    }, [])

    return (
        <>
            <HeaderDesktop mId={merchantId} active="shop"/>


            <div className="basket-responsive-wrapper">
                <div className="basket-responsive-container">

                    <div className="basket-responsive-invoice">

                        <div className="basket-responsive-invoice-sec">
                            <div className="basket-responsive-invoice-row">
                                <span>مجموع</span>
                                <span> {finalObj && numberWithCommas(finalObj.invoice.order.original_amount)} ریال </span>
                            </div>

                            <div className="basket-responsive-invoice-row red-row">
                                <span>مجموع تخفیف اقلام</span>
                                <span> {finalObj && numberWithCommas(finalObj.invoice.discount_amount+finalObj.invoice.order.discount)} ریال </span>
                            </div>

                            <div className="basket-responsive-invoice-row">
                                <span>مبلغ قابل پرداخت</span>
                                <span> {finalObj && numberWithCommas(finalObj.invoice.payable_amount)} ریال </span>
                            </div>
                        </div>

                        <div className="basket-responsive-invoice-btn" onClick={e => {
                            redirectToGateWay()
                        }}>
                            <span>پرداخت</span>
                        </div>
                    </div>

                    <div className="basket-responsive-body">
                        <div className="basket-responsive-body-banner">
                            <img
                                src="https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/%D8%A8%D9%87%D8%AF%D8%A7%D8%B4%D8%AA%DB%8C_1_qfNBfTW.png"
                                alt=""/>
                        </div>

                        <div className="basket-responsive-body-content">

                            <div className="basket-info-section">
                                <div className="total-section">
                                    <span>{finalObj && finalObj.invoice && finalObj.invoice.merchant.name}</span>
                                    <span>پذیرنده</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.order.original_amount)} ریال </span>
                                    <span>مبلغ فاکتور</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && finalObj.invoice && finalObj.invoice.courier_cost && numberWithCommas(finalObj.invoice.courier_cost)} ریال </span>
                                    <span>هزینه پیک</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && finalObj.invoice && finalObj.invoice.packing_cost && numberWithCommas(finalObj.invoice.packing_cost)} ریال </span>
                                    <span>هزینه بسته بندی</span>
                                </div>
                                <div className="price-section">
                                    <span> {finalObj && finalObj.invoice && finalObj.invoice.tax_cost && numberWithCommas(finalObj.invoice.tax_cost)} ریال </span>
                                    <span>مالیات بر ارزش افزوده</span>
                                </div>
                                <div className="off-section indent-item">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.order.discount)} ریال </span>
                                    <span>تخفیف اقلام</span>
                                </div>
                                <div className="off-section indent-item">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.discount_amount)} ریال </span>
                                    <span>تخفیف کوپن</span>
                                </div>


                                {/*{finalObj && finalObj.rewards.map(j=>{*/}
                                {/*    return(*/}
                                {/*      <RewardInInvoice item={j}/>*/}
                                {/*    )*/}
                                {/*})}*/}

                                {finalObj && finalObj.invoice.coupon ?
                                    <div className="off-sub-section" >
                                        {finalObj.invoice.coupon.coupon_type==="discount_percent"?
                                            <span> {convertPerToAm(
                                                finalObj.invoice.coupon.discount_value,
                                                finalObj.invoice.coupon.max_discount_amount,
                                                finalObj.invoice.amount
                                            )} ریال </span>:
                                            <span> {numberWithCommas(finalObj.invoice.coupon.discount_value)} ریال </span>
                                        }

                                        <span>{finalObj.invoice.coupon.title}</span>
                                    </div>:null
                                }

                                <div className="off-section">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.discount_amount+finalObj.invoice.order.discount)} ریال </span>
                                    <span>مجموع تخفیف</span>
                                </div>

                                <div className="price-section">
                                    <span> {finalObj && numberWithCommas(finalObj.invoice.payable_amount)} ریال </span>
                                    <span>مبلغ قابل پرداخت</span>
                                </div>


                                {finalObj && finalObj.rewards && finalObj.rewards.length>0?<div className="invoice-reward-t-sec">
                                    <div className="invoice-reward-t-header">
                                        <span>پاداش های شما از این خرید</span>
                                        <i className="fa fa-gift"></i>
                                    </div>
                                    {finalObj && finalObj.rewards.map(j=>{
                                        return(
                                            <RewardInInvoice item={j}/>
                                        )
                                    })}
                                </div>:null}

                            </div>

                            <div className="ticket-section">
                                <div className="add-ticket-section" onClick={() => {
                                    set_showModal(true)
                                }}>
                                    <span> وارد کردن کد تخفیف </span>
                                    <i className="fa fa-plus"></i>
                                </div>
                                <div className="title-section">
                                    : کوپن های شما در این فروشگاه
                                </div>
                            </div>

                            <Rodal
                                customStyles={{
                                    height: 'auto !important',
                                    bottom: 'auto',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '300px'
                                }}
                                animation={"zoom"} visible={showModal} onClose={() => set_showModal(false)}>
                                <div className="coupons_modal">
                                    <span className="modal-title">کد تخفیف خود را وارد نمایید </span>
                                    <input type="text"
                                           onChange={(e) => {
                                               set_coupon(e.target.value)
                                           }}
                                           value={coupon}
                                           name="" id="" placeholder="کد تخفیف"/>
                                    <span className="modal-btn" onClick={() => {
                                        addCoupon();
                                    }}>
                        {couponStatus ? "... در حال ثبت" : "ثبت"}
                        </span>
                                </div>
                            </Rodal>


                            {finalObj && finalObj.rewards ? <div className="storeDetail-rewards">

                                {couponsList.map(i=>{
                                    return(
                                        <CouponComponent final={coupon_finalize} item={i}/>
                                    )
                                })}
                            </div> : null}

                        </div>

                    </div>

                </div>
            </div>

            <br/><br/>
            <FooterDesktop/>
        </>
    )

}

export default PaymentResponsive
